import { __decorate } from "tslib";
import { AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { Payment } from '../members/Payment.js';
import { Invoice } from '../billing/Invoice.js';
/**
 * If needed, you can extend this class to add extra fields in custom checkout flows.
 */
export class CheckoutResponse extends AutoEncoder {
    constructor() {
        super(...arguments);
        /**
         * Used for polling the payment status or showing transfer instructions.
         * Also used for showing a summary on the success page.
         */
        this.payment = null;
        /**
         * If an invoice is available and created, it will be set here already.
         * When asked for a pro forma invoice, this will be set.
         */
        this.invoice = null;
        /**
         * External page to finish the payment
         */
        this.paymentUrl = null;
        /**
         * Data to put in a QR-code (alternative for the paymentUrl)
         * E.g. Payconiq/Wero payment QR-code
         */
        this.paymentQRCode = null;
    }
}
__decorate([
    field({ decoder: Payment, nullable: true })
], CheckoutResponse.prototype, "payment", void 0);
__decorate([
    field({ decoder: Invoice, nullable: true })
], CheckoutResponse.prototype, "invoice", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], CheckoutResponse.prototype, "paymentUrl", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], CheckoutResponse.prototype, "paymentQRCode", void 0);
//# sourceMappingURL=CheckoutResponse.js.map